import {
  Box,
  Button,
  Grid,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import NewAppBar from "components/Navbars/AppBar";
import { useEffect, useState, useCallback } from "react";
import Footer from "views/Landing/Footer";
import arrowBack from "../../assets/img/Vector.svg";
import axios from "axios";
import { ModernLoader } from "components/Loading/LoadingDots";
import { useSnackbar } from "hooks/useSbackbar";
import useUserId from "hooks/useUserId";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ApplicationForm from "./ApplicationForm";
import JobDetailPage from "./EmptyJobState ";
import JobCard from "./JobCard";
import useFetchUser from "hooks/useFetchUser";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: "Poppins",
    borderColor: "#00000033",
    backgroundColor: "#fff",
    transition: "border-color 0.4s ease, box-shadow 0.4s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      boxShadow: "0px 4px 20px rgba(0, 23, 231, 0.1)",
      borderColor: "#0017E7",
      transition: "all 0.3s ease",
    },
    "& .MuiOutlinedInput-input": {
      minHeight: "36px",
      padding: "8px 14px",
    },
  },
}));

const FastApplyPage = ({ setHiddforum = () => { } }) => {
  const state = useLocation().state;

  const [formData, setFormData] = useState({
    academicDegree: "",
    lastPostOccupied: "",
    linkedinProfile: "",
    dateOfBirth: null,
    familyStatus: "",
    fieldOfStudy: "",
    resumeUploaded: false,
    coverLetterUploaded: false,
  });
  // const formData = new FormData();

  const [formErrors, setFormErrors] = useState({});
  const [uploadedFilesList, setUploadedFilesList] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFilename, setSelectedFilename] = useState(null);
  const location = useLocation();
  const { job, cameFromLogin } = location.state || {};
  const { t } = useTranslation();
  const userid = useUserId();
  const userId = userid.userId;
  const apiUrl = process.env.REACT_APP_API_URL;
  const { showSnackbar } = useSnackbar();
  const [uploadedFiles, setUploadedFiles] = useState({ resumes: null });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadedResume, setUploadedResume] = useState();
  const [resumeUploaded, setResumeUploaded] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const [hasAppliedToThisPost, setHasAppliedToThisPost] = useState(false); // Changed from true to false
  const [resetTrigger, setResetTrigger] = useState(false);
  const [applied, setApplied] = useState(false); // Changed from true to false
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [coverLetterText, setCoverLetterText] = useState("");
const [useMatchingProfile, setUseMatchingProfile] = useState(false);
  const userInfo = useFetchUser();
  // useEffect(() => {
  //   console.log('userInfoxx@@', userInfo)
  // }, [userInfo])
  
  useEffect(() => {
    console.log('FastApplyPage coverLetterText state updated to:', coverLetterText);
  }, [coverLetterText]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const navigate = useNavigate();

  // Fix: Move the useEffect to handle job data properly
  useEffect(() => {
    console.log("Job data received:", job);

    if (!job) {
      console.log("No job data found in location state");
      // Try to get job from localStorage as fallback
      const storedJob = localStorage.getItem("job");
      if (storedJob) {
        try {
          const parsedJob = JSON.parse(storedJob);
          // Don't mutate location.state directly
          setHasAppliedToThisPost(parsedJob.has_applied || false);
        } catch (error) {
          console.error("Error parsing stored job data:", error);
        }
      }
    } else {
      // Set applied status based on job data
      setHasAppliedToThisPost(job.has_applied || false);
    }
  }, [job]);

  // Fix: Move validation logic inside the postApplied function
  const postApplied = async (coverLetterFile = null) => {
    try {
      // If using matching profile, call the matching API instead
      if (useMatchingProfile) {
        const candidateId = userId;
        if (!candidateId) {
          showSnackbar("Please login to use matching profile", {
            severity: "error",
            position: "bottom-left",
            duration: 3000,
          });
          return { error: "User not logged in" };
        }

        const endpoint = `${apiUrl}candidates/application/create-matching-profile/`;
        const body = {
          candidate: candidateId,
          post: [job.id],
        };

        try {
          const response = await axios.post(endpoint, body);
          console.log('Response v2: ', response);

          if (response.status === 200 || response.status === 201) {
            showSnackbar(t("applicationForm.applicationSubmitted"), {
              severity: "success",
              position: "bottom-left",
              duration: 3000,
            });
            setApplied(true);
            setIsClicked(false);
            return response.data;
          }
        } catch (error) {
          console.error('Error applying:', error);
          showSnackbar("Une erreur est survenue lors de la postulation, vous pouvez postuler qu'une seule fois pour chaque poste", {
            severity: "error",
            position: "bottom-left",
            duration: 3000,
          });
          return { error: error.message };
        }
      }

      // Original resume upload logic
      // Validate inputs before creating FormData
      const newErrors = {};
      if (!firstName) newErrors.firstName = "First name is required";
      if (!lastName) newErrors.lastName = "Last name is required";
      if (!email) newErrors.email = "Email is required";
      if (!uploadedResume) newErrors.resume = "Resume is required";
      if (!userId) {
        if (Object.keys(newErrors).length > 0) {
          setFormErrors(newErrors);
          showSnackbar("Please fill in all required fields", {
            severity: "error",
            position: "bottom-left",
            duration: 3000,
          });
          return { error: "Validation failed" };
        }

      }


      if (!uploadedResume) {
        console.error("No resume file provided");
        return { error: "Resume file is required" };
      }



      // Create FormData for file uploads
      const submitFormData = new FormData();

      if (!userId) {
        submitFormData.append("first_name", firstName.trim());
        submitFormData.append("last_name", lastName.trim());
        submitFormData.append("email", email.trim());
        submitFormData.append("cv", uploadedResume);
      } else {
        console.log("first_name", userInfo.formData.first_name);
        console.log("last_name", userInfo.formData.last_name);
        console.log("email", userInfo.formData.email);
        submitFormData.append("first_name", userInfo.formData.first_name);
        submitFormData.append("last_name", userInfo.formData.last_name);
        submitFormData.append("email", userInfo.formData.email);
        submitFormData.append("cv", uploadedResume);
      }

      if (coverLetterFile) {
        submitFormData.append("cover_letter", coverLetterFile);
      }
      // submitFormData.append("recruiter_email", userInfo.email);

      // Debug: Log submitFormData contents
      console.log("submitFormData contents:");
      for (let [key, value] of submitFormData.entries()) {
        console.log(`${key}:`, value);
      }

      const url = `${apiUrl}authentication/apply_to_fast_post/${job.id}/`;
      console.log("Request URL:", url);

      const response = await fetch(url, {
        method: "POST",
        body: submitFormData,
      });

      console.log("Response status:", response.status);
      console.log("Response headers:", response.headers);

      if (!response.ok) {
        const responseText = await response.text();
        console.error("Response text:", responseText);
        showSnackbar(t("applicationForm.alreadyApplied"), {
          severity: "warning",
          position: "bottom-left",
          duration: 3000,
        });
        try {
          const errorData = JSON.parse(responseText);
          console.error("Error data:", errorData);

          if (response.status === 404) {
            return { error: "Post not found" };
          } else if (response.status === 400) {
            return { error: errorData.error || "Application failed" };
          } else {
            return { error: `Server error: ${response.status}` };
          }
        } catch (parseError) {
          console.error("Could not parse error response:", parseError);
          return { error: `HTTP ${response.status}: ${response.statusText}` };
        }
      }

      const json = await response.json();
      console.log("Success response:", json);
      setApplied(json.is_applied);
      setIsClicked(false);

      // Clear form after successful submission
      setFirstName("");
      setLastName("");
      setEmail("");
      setUploadedResume(null);
      setSelectedFile(false);
      setCoverLetterText("");
      setUploadedFilesList({}); // Clear both resume and cover letter fields
      setFormData((prev) => ({
        ...prev,
        resumeUploaded: false,
        coverLetterUploaded: false,
        selectedFileName: null,
      }));

      showSnackbar(t("applicationForm.applicationSubmitted"), {
        severity: "success",
        position: "bottom-left",
        duration: 3000,
      });

      return json;
    } catch (error) {
      showSnackbar(t("applicationForm.applicationSubmitted"), {
        severity: "warning",
        position: "bottom-left",
        duration: 3000,
      });
      console.error("Network or other error:", error);
      return { error: error.message };
    }
  };

  const navigateBack = () => {
    // Get the state from location
    const { cameFromLogin } = location.state || {};

    // If we came from login, go to landing
    if (cameFromLogin) {
      navigate("/landing");
      return;
    }

    // Otherwise try to go back
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate("/landing");
    }
  };

  const handleFileSelect = (fileKey, file) => {
    console.log("Selecting file:", fileKey, file);

    if (!fileKey) {
      // Unchecking
      setSelectedFile(null);
      setResumeUploaded(false);
      setUploadedResume(null);
      setFormData((prev) => ({
        ...prev,
        resumeUploaded: false,
        selectedFileName: null,
      }));
      return;
    }

    // Selecting new file
    setSelectedFile(fileKey);
    setResumeUploaded(true);
    setUploadedResume(file);

    // Get the file name in the original format
    let fileName;
    if (file.resume) {
      fileName = file.resume.split("/").pop();
    } else if (file.name) {
      fileName = file.name;
    } else if (file.path) {
      fileName = file.path.split("/").pop();
    } else if (typeof file === "string") {
      fileName = file.split("/").pop();
    }

    console.log("Selected file name:", fileName);
    setSelectedFilename(fileName);
    setFormData((prev) => ({
      ...prev,
      resumeUploaded: true,
      selectedFileName: fileName,
    }));
  };

  const handleFileUpload = (event, fileType) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      // Uncheck any previously selected file
      setSelectedFile(null);
      setUploadedResume(file);
      setResumeUploaded(true);

      if (fileType === "resume") {
        setFormData((prev) => ({
          ...prev,
          resumeUploaded: true,
          selectedFileName: file.name,
        }));
        setSelectedFilename(file.name);
        console.log("New resume uploaded:", file.name);
      } else {
        setFormData((prev) => ({
          ...prev,
          coverLetterUploaded: true,
        }));
      }

      setUploadedFilesList((prev) => ({
        ...prev,
        [fileType]: file,
      }));

      // Reset the file input
      event.target.value = "";
    }
  };

  const handleFileDelete = (key) => {
    setUploadedFilesList((prev) => {
      const newFiles = { ...prev };
      delete newFiles[key];
      return newFiles;
    });
    if (key === "resume") {
      setFormData((prev) => ({ ...prev, resumeUploaded: false }));
    } else {
      setFormData((prev) => ({ ...prev, coverLetterUploaded: false }));
    }
  };

  const onSubmit = async (data) => {
    console.log("[1] Submitting application...");
    console.log("[2] Current resume state:", {
      uploadedResume,
      selectedFile,
      resumeUploaded,
      formDataResumeUploaded: formData.resumeUploaded,
      uploadedFilesList,
      selectedFilename,
      uploadedFiles,
    });

    // Ensure resume state is synchronized
    if (formData.resumeUploaded && !resumeUploaded) {
      setResumeUploaded(true);
    }
    setIsSubmitting(true);
    try {
      console.log("[3] Form validation passed. Preparing FormData...");

      const applicationFormData = new FormData();

      if (isNaN(state.job.id)) {
        throw new Error("Invalid post ID: must be a number");
      }

      applicationFormData.append("post", state.job.id);
      applicationFormData.append("candidate", userId);
      applicationFormData.append("status", "p");

      console.log("[4] Post ID:", state.job.id, "type:", typeof state.job.id);
      let resumeHandled = false;
      console.log("[8] Starting resume handling...");

      // 1. Check for newly uploaded resume
      if (uploadedResume) {
        console.log("[9] Processing uploadedResume:", uploadedResume);
        if (typeof uploadedResume === "string") {
          const relativePath = uploadedResume.split("media/").pop();
          applicationFormData.append("resume_path", relativePath);
          resumeHandled = true;
          console.log("[9.1] Added resume path from string:", relativePath);
        } else if (uploadedResume instanceof File) {
          applicationFormData.append("resume", uploadedResume);
          applicationFormData.append(
            "resume_path",
            `resumes/post_${state.job.id}/${standardizeFilename(
              uploadedResume.name
            )}`
          );
          resumeHandled = true;
          console.log("[9.2] Added resume file:", uploadedResume.name);
        }
      }

      // 2. Check for selected file from list
      if (!resumeHandled && selectedFile && uploadedFilesList[selectedFile]) {
        console.log("[10] Processing selected file:", selectedFile);
        const file = uploadedFilesList[selectedFile];
        if (file.resume) {
          const relativePath = file.resume.split("media/").pop();
          applicationFormData.append("resume_path", relativePath);
          resumeHandled = true;
          console.log(
            "[10.1] Added resume path from selected file:",
            relativePath
          );
        }
      }

      // 3. Check for file from form data
      if (!resumeHandled && data.resume && data.resume[0]) {
        console.log("[11] Processing form data resume");
        applicationFormData.append("resume", data.resume[0]);
        applicationFormData.append(
          "resume_path",
          `resumes/post_${state.job.id}/${standardizeFilename(
            data.resume[0].name
          )}`
        );
        resumeHandled = true;
        console.log("[11.1] Added resume from form data:", data.resume[0].name);
      }

      // 4. Check for resume in uploadedFiles
      if (!resumeHandled && uploadedFiles.resumes) {
        console.log("[12] Processing resume from uploadedFiles");
        if (typeof uploadedFiles.resumes === "string") {
          const relativePath = uploadedFiles.resumes.split("media/").pop();
          applicationFormData.append("resume_path", relativePath);
          resumeHandled = true;
          console.log(
            "[12.1] Added resume path from uploadedFiles:",
            relativePath
          );
        }
      }

      if (!resumeHandled) {
        console.log("[13] No resume found in any source. Current state:", {
          uploadedResume,
          selectedFile,
          resumeUploaded,
          formDataResumeUploaded: formData.resumeUploaded,
          uploadedFilesList,
          uploadedFiles,
          selectedFilename,
        });
        throw new Error(t("applicationForm.noResumeSelected"));
      }

      console.log("[14] Resume handled successfully");

      // Handle cover letter
      if (data.cover_letter && data.cover_letter[0]) {
        applicationFormData.append("cover_letter", data.cover_letter[0]);
        console.log("[15] Cover letter added:", data.cover_letter[0].name);
      }

      // Log all form data being sent
      console.log("[16] Final form data being submitted:");
      for (let [key, value] of applicationFormData.entries()) {
        console.log(`${key}: ${value instanceof File ? value.name : value}`);
      }

      // Submit application
      console.log("[17] Submitting application to backend...");
      // await submitApplication(applicationFormData);
      console.log("[18] Application submitted successfully.");
      setIsClicked(true);
      if (typeof setHiddforum === "function") {
        setHiddforum(true);
      }
      setHasAppliedToThisPost(true);
      reset();
      // Trigger reset in child component
      setResetTrigger((prev) => !prev);
      console.log("[19] Form reset, UI updated.");
    } catch (error) {
      console.log("[20] Caught error:", error);
      console.error(
        t("applicationForm.errorSubmittingApplication"),
        error.response?.data || error.message
      );

      if (error.response && error.response.data) {
        showSnackbar(
          `Submission error: ${JSON.stringify(error.response.data)}`,
          {
            severity: "error",
            position: "bottom-left",
            duration: 5000,
          }
        );
      } else {
        showSnackbar(`Error: ${error.message}`, {
          severity: "error",
          position: "bottom-left",
          duration: 5000,
        });
      }
    } finally {
      console.log("[21] Submission complete. isSubmitting set to false.");
      setIsSubmitting(false);
    }
  };

  const standardizeFilename = (filename) => {
    // Remove any leading/trailing spaces
    let cleanName = filename.trim();
    // Replace spaces with underscores
    cleanName = cleanName.replace(/\s+/g, "_");
    return cleanName;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleDateChange = (newValue) => {
    setFormData((prevData) => ({ ...prevData, dateOfBirth: newValue }));
    if (formErrors.dateOfBirth) {
      setFormErrors((prev) => ({ ...prev, dateOfBirth: null }));
    }
  };

  const handleCoverLetterChange = useCallback((event) => {
    console.log('handleCoverLetterChange called with:', event.target.value);
    setCoverLetterText(event.target.value);
    console.log('coverLetterText state should be:', event.target.value);
  }, []);

  // const handlePostuler = async () => {
  //   const candidateId = userId;

  //   console.log('Data we are sending: ', candidateId, '---', [job.id]);

  //   const endpoint = `${apiUrl}candidates/application/create-matching-profile/`;
  //   const body = {
  //     candidate: candidateId,
  //     post: [job.id],
  //   };

  //   try {
  //     const response = await axios.post(endpoint, body);
  //     console.log('Response v2: ', response);

  //     if (response.status === 200 || response.status === 201) {
  //       showSnackbar(t("applicationForm.applicationSubmitted"), {
  //         severity: "success",
  //         position: "bottom-left",
  //         duration: 3000,
  //       });
  //       setApplied(true);
  //     }
  //   } catch (error) {
  //     console.error('Error applying:', error);
  //     showSnackbar("Une erreur est survenue lors de la postulation, vous pouvez postuler qu'une seule fois pour chaque poste", {
  //       severity: "error",
  //       position: "bottom-left",
  //       duration: 3000,
  //     });
  //   }
  // };

  const handlePostuler = async () => {
    const candidateId = userId;
    console.log('Data we are sending: ', candidateId, '---', job.id);

    const endpoint = `${apiUrl}candidates/application/create-matching-profile/`;
    const body = {
      candidate: candidateId,
      post: [job.id],
    };

    try {
      setIsSubmitting(true);
      const response = await axios.post(endpoint, body);
      console.log('Response v2: ', response);

      if (response.status === 200 || response.status === 201) {
        showSnackbar(t("applicationForm.applicationSubmitted"), {
          severity: "success",
          position: "bottom-left",
          duration: 3000,
        });
        setApplied(true);
        setHasAppliedToThisPost(true);
      }
    } catch (error) {
      console.error('Error applying:', error);
      showSnackbar(t("applicationForm.alreadyApplied"), {
        severity: "error",
        position: "bottom-left",
        duration: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Fix: Add early return for no job data
  if (!job) {
    console.log("Rendering empty state - no job data available");
    return <JobDetailPage />;
  }

  return (
    <Box>
      <NewAppBar />
      <Box
        sx={{
          mx: "auto",
          py: { xs: 4, md: 8 },
          px: { xs: 2, sm: 4, md: 7 },
          maxWidth: "1300px",
          width: "100%",
          margin: "0 auto",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={navigateBack}
          sx={{
            alignSelf: "flex-start",
            fontFamily: "Poppins",
            fontSize: "14px",
            textTransform: "none",
            mb: 4,
            padding: "14px 26px 14px 26px",
            borderRadius: "11px",
          }}
        >
          <img src={arrowBack} width={13} height={13} alt="Back arrow" />
          <Typography
            sx={{
              marginLeft: 1,
            }}
          >
            {t("applicationPage.jobDetails")}
          </Typography>
        </Button>

        <JobCard job={job} />

        <Typography
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: { xs: "24px", md: "32px" },
            lineHeight: "100%",
            letterSpacing: "0%",
            color: "#0017E7",
            marginBottom: 4,
          }}
        >
          {t("applicationPage.applyForOffer")}
        </Typography>

        {userId === null ? (
          <Grid container columnSpacing={5} rowSpacing={4}>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  color: "#0000004D",
                  fontSize: "13px",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  mb: 1,
                }}
              >
                {t("personalInformation.firstName")}
              </Typography>
              <StyledTextField
                fullWidth
                name="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  color: "#0000004D",
                  fontSize: "13px",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  mb: 1,
                }}
              >
                {t("personalInformation.lastName")}
              </Typography>
              <StyledTextField
                fullWidth
                name="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ pb: 6 }}>
              <Typography
                sx={{
                  color: "#0000004D",
                  fontSize: "13px",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  mb: 1,
                }}
              >
                {t("personalInformation.email")}
              </Typography>
              <StyledTextField
                fullWidth
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                variant="outlined"
              />
            </Grid>
          </Grid>
        ) : null}

        <ApplicationForm
          formData={formData}
          setFormData={setFormData}
          formErrors={formErrors}
          setFormErrors={setFormErrors}
          handleInputChange={handleInputChange}
          handleDateChange={handleDateChange}
          handleFileUpload={handleFileUpload}
          uploadedFilesList={uploadedFilesList}
          handleFileSelect={handleFileSelect}
          handleFileDelete={handleFileDelete}
          handleSubmit={handleSubmit(onSubmit)}
          hasApplied={hasApplied}
          register={register}
          selectedFile={selectedFile}
          selectedFilename={selectedFilename}
          isSubmitting={isSubmitting}
          resetTrigger={resetTrigger}
          job={job}
          coverLetterText={coverLetterText}
          onCoverLetterChange={handleCoverLetterChange}
          useMatchingProfile={useMatchingProfile}
          setUseMatchingProfile={setUseMatchingProfile}
          handlePostuler={handlePostuler}
        />
        {/* Debug log */}
        {console.log('Passing to ApplicationForm:', { coverLetterText, handleCoverLetterChange })}
        {userid.role !== "r" || userid.role !== null ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-end" },
              marginTop: 4,
            }}
          >
            <Button
              variant="contained"
              onClick={useMatchingProfile ? handlePostuler : handleSubmit(postApplied)}
              disabled={isSubmitting || hasAppliedToThisPost || applied}
              sx={{
                bgcolor: "#0017e7",
                color: "#fff",
                width: { xs: "100%", sm: "177px" },
                height: "50px",
                borderRadius: "11px",
                padding: "14px 16px",
                gap: "10px",
                textTransform: "none",
              }}
              type="submit"
              form="application-form"
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                }}
              >
                {isSubmitting ? (
                  <Box
                    sx={{ display: "flex", flexDirection: "row", gap: "10px" }}
                  >
                    <ModernLoader size={24} />
                    {t("applicationPage.applyForOffer")}
                  </Box>
                ) : (
                  t("applicationPage.applyForOffer")
                )}
              </Typography>
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-end" },
              marginTop: 4,
            }}
          >
            <Button
              variant="contained"
              disabled={true}
              sx={{
                bgcolor: "#0017e7",
                color: "#fff",
                width: { xs: "100%", sm: "177px" },
                height: "50px",
                borderRadius: "11px",
                padding: "14px 16px",
                gap: "10px",
                textTransform: "none",
              }}
              type="submit"
              form="application-form"
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                }}
              >
                {t("applicationPage.notAvailableForRecruiters")}
              </Typography>
            </Button>
          </Box>
        )}
      </Box>
      <Footer />
    </Box>
  );
};

export default FastApplyPage;
